import { render, staticRenderFns } from "./FounderBlock.vue?vue&type=template&id=738a9056"
import script from "./FounderBlock.vue?vue&type=script&lang=js"
export * from "./FounderBlock.vue?vue&type=script&lang=js"
import style0 from "./FounderBlock.vue?vue&type=style&index=0&id=738a9056&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports